module.exports = __webpack_public_path__ + "static/media/34DSS1.30400136.jpg";